module.exports = __webpack_public_path__ + "img/box_middle.0b034dbb.png";